import { values } from './enums'

const _enum = {
  Unknown: 0,
  Individual: 1,
  Company: 2,
  Bank: 3,
  Institution: 9
}

export const personTypes = {
  enumName: 'PersonTypes',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/PersonTypes.js